<div *ngIf="showAnnouncement" class="ticker-tape-container" [ngClass]="{'pointer-cursor': isClickable()}"
    (click)="onClickRedirect()">
    <app-ticker-tape [items]="tickerItems" [speed]="10"></app-ticker-tape>
</div>